import React from "react";
import {
  RopeDetailModalKeyClass,
  RopeDetailModalKeyWidth,
  RopeDetailModalWidth,
  RopeMessage
} from "../../types/Rope";
import { Modal, Table } from "antd";
import { Link } from "react-router-dom";
import { formatDateTime } from "../../utils/formatDateTime";

type RopeMessageRecordModalProps = {
  modalState: boolean;
  closeModal: () => void;
  record: RopeMessage | null;
};

const RopeMessageRecordModal = (props: RopeMessageRecordModalProps) => {
  const columns = [
    {
      title: "Detail",
      key: "k",
      className: RopeDetailModalKeyClass,
      dataIndex: "k",
      width: RopeDetailModalKeyWidth
    },
    {
      title: "Text",
      key: "v",
      render: (text, row) => {
        switch (row.k) {
          case "Created By":
            return row.v && props.record ? (
              <Link to={`/employees/${props.record.createdById}`}>{row.v}</Link>
            ) : (
              ""
            );
          case "Created At":
            return row.v ? formatDateTime(row.v) : "";
          default:
            return row.v;
        }
      }
    }
  ];
  let data = [{}];

  if (props.record) {
    data = [
      {
        k: "Message ID",
        v: props.record.id
      },
      { k: "Level", v: props.record.level },
      { k: "Type", v: props.record.type },
      { k: "Message", v: props.record.message },
      { k: "Created At", v: props.record.createdAt },
      { k: "Created By", v: props.record.createdBy }
    ];
  }

  return (
    <Modal
      title={"View Message Record"}
      visible={props.modalState}
      onCancel={props.closeModal}
      footer={null}
      width={RopeDetailModalWidth}
    >
      <Table
        pagination={false}
        showHeader={false}
        columns={columns}
        dataSource={data}
        rowKey="k"
      />
    </Modal>
  );
};

export default RopeMessageRecordModal;
